import { cn as e } from "../utils/index.js";
import "react";
import { Fragment as t, jsx as n } from "react/jsx-runtime";
import { cva as r } from "class-variance-authority";
import { Slot as i } from "@radix-ui/react-slot";
import a from "lodash/uniqueId";
//#region src/components/button.tsx
var o = r("inline-flex items-center justify-center gap-2 whitespace-nowrap text-sm cursor-pointer font-bold transition-all disabled:pointer-events-none [&_svg]:pointer-events-none [&_svg:not([class*='size-'])]:size-4 shrink-0 [&_svg]:shrink-0 outline-none focus-visible:border-ring focus-visible:ring-ring/50 focus-visible:ring-[3px] aria-invalid:ring-destructive/20 aria-invalid:border-destructive", {
	variants: {
		variant: {
			default: "bg-grad text-white border-intent hover:bg-grad-dark disabled:bg-none disabled:bg-(--neutral-50) disabled:text-(--neutral-400) ",
			destructive: "bg-destructive text-white hover:bg-destructive/90 focus-visible:ring-destructive/20",
			outline: "border bg-background rounded border-(--seafoam-600) text-(--seafoam-600) shadow-xs hover:bg-accent hover:text-accent-foreground",
			secondary: e("bg-grad border-intent text-(--seafoam-600) p-[2px]", "hover:bg-(--seafoam-500) hover:bg-none", "disabled:bg-none disabled:bg-(--neutral-100) disabled:text-(--neutral-400)", "*:[span]:text-(--seafoam-600) *:[span]:bg-white *:[span]:border-intent-span *:[span]:p-1 *:[span]:px-2  hover:*:[span]:bg-(--seafoam-500) hover:*:[span]:text-white"),
			tertiary: e("rounded-[5px] p-[2px]", "data-[state=on]:bg-grad", "hover:bg-(--seafoam-500) hover:bg-none", "disabled:bg-none disabled:bg-(--neutral-100) disabled:text-(--neutral-400)", "*:[span]:bg-(--neutral-50)  *:[span]:text-(--neutral-500) *:[span]:rounded-[4px] hover:*:[span]:bg-(--seafoam-500) hover:*:[span]:text-white", "data-[state=on]:*:[span]:text-(--seafoam-600) data-[state=on]:*:[span]:bg-white data-[state=on]:hover:*:[span]:bg-(--seafoam-500) data-[state=on]:hover:*:[span]:text-white"),
			ghost: "hover:bg-accent hover:text-accent-foreground",
			link: "text-(--neutral-900) hover:text-(--neutral-600)",
			"link-green": "text-(--seafoam-500) hover:text-(--seafoam-600)"
		},
		size: {
			default: "py-1.5 px-5 has-[>svg]:px-3 font-bold-16",
			sm: "py-1 px-3 has-[>svg]:px-2.5 font-short-14",
			lg: "py-2 px-5 font-bold-16",
			icon: "size-6",
			"secondary-sm": "font-short-14",
			"secondary-md": "font-reg-16",
			"icon-sm": "size-5",
			"icon-lg": "size-8 *:[span]:p-1.75"
		}
	},
	defaultVariants: {
		variant: "default",
		size: "default"
	}
});
function s({ className: r, variant: s = "default", size: c = "default", asChild: l = !1, ...u }) {
	let d = a("intentsify-"), f = l ? i : "button", { children: p, ...m } = u;
	return /* @__PURE__ */ n(f, {
		"data-slot": "button",
		"data-variant": s,
		"data-size": c,
		className: e(o({
			variant: s,
			size: c
		}), r, d),
		...m,
		children: s === "secondary" ? /* @__PURE__ */ n("span", {
			className: "w-full flex items-center justify-center",
			children: p
		}) : /* @__PURE__ */ n(t, { children: p })
	});
}
//#endregion
export { s as Button, o as buttonVariants };
